module.exports = __webpack_public_path__ + "img/ico_extrato-participacao-financeira.f1045a84.svg";